<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="true"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-md-12 col-12">
        <ol class="breadcrumb" style="margin-top: 20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item active">Список описів книжок</li>
        </ol>
      </div>
    </div>
    <div class="card">
      <div class="card-body" style="overflow-x: auto">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4">
                <label for="filter" class="floatings">Фільтрувати поле:</label>
                <div class="w-100 d-inline-block">
                  <v-select id="filter"
                            :options="fields"
                            label="name"
                            v-model="filterField"
                            @input="getFieldValues(filterField.field, '');"
                            :searchable="false"
                            @close="getDescriptions()"
                            @open="filterValue = null; changeValue = null"
                  >
                    <template #no-options="{ search, searching, loading }">
                      Категорії не знайдено
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-4">
                <label for="value" class="floatings">Фільтрувати по значенню:</label>
                <div class="w-100 d-inline-block" >
                  <v-select id="value"
                            :disabled="!filterField || showEmptyField"
                            label="name"
                            :options="filterValues"
                            v-model="filterValue"
                            :filterable="false"
                            @search="getFieldValues(filterField.field, $event);"
                            @input="getDescriptions($event)"
                  >
<!--                    @search:focus="getFieldValues(filterField.field, '')"-->

                    <!--                    @close="getDescriptions()"-->

                    <template #no-options="{ search, searching, loading }">
                      Категорії не знайдено
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-4">
                <label for="change" class="floatings">Замінити на</label>
                <div class="w-100 d-inline-block">
                  <v-select
                            :disabled="!filterField"
                            id="change"
                            v-model="changeValue"
                            @search="getFieldValues(filterField.field, $event)"
                            @search:focus="getFieldValues(filterField.field, '')"
                            :options="filterValues"
                            label="name"
                            :taggable="filterValues.length != 1"
                            :filterable="false"
                  >
                    <template #no-options="{ search, searching, loading }">
                      Категорії не знайдено
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row m-t-30">
<!--              <div class="col-6">-->
<!--                <div class="row">-->
                  <div class="col-3">
                    <b-form-checkbox v-model="showEmptyField" name="check-button" switch >
                      Відображати пусті значення
                    </b-form-checkbox>
                  </div>
                  <div class="col-3">
<!--                    <img src="/theme/icons/calendar.svg" alt="">-->
                    <date-picker v-model="dateFilter" range @input="getDescriptions()"></date-picker>
              </div>
              <div class="col-6 text-right">
                <b-button variant="outline-primary m-r-20" style="height:47px" @click="reset();">Скинути</b-button>
                <b-button variant="success" style="height:47px" @click="massUpdate()">Зберегти</b-button>
              </div>
            </div>
            <div class="row">
                <h6 v-if="filterValue" class="card-subtitle m-t-0 p-l-10">
                  Знайдено за запитом - <strong>{{ total }}</strong>
                </h6>
                <h6 v-else class="card-subtitle m-t-0">
                  Всього записів - <strong>{{ total }}</strong>
                </h6>
            </div>
            <div class="row">
              <table class="table reader table-books">
                <thead>
                <tr>
                  <th>
                    <b-form-checkbox
                        v-model="checkedAll"
                        @input="checkAll()">
                    </b-form-checkbox>
                  </th>
                  <th>
                    Заголовок
                  </th>
                  <th :class="filterField != null && filterField.field == 'author' ? 'bg-success text-white' : ''">
                    Автор
                  </th>
                  <th v-if="filterField != null && filterField.field != 'author'" class="bg-success text-white">
                      {{ filterField.name }}
                  </th>
                  <th>
                    Рік видання
                  </th>
                  <th>
                    Видавництво
                  </th>
                  <th>
                    Місце видання
                  </th>
                  <th class="text-center">
                    Створенно
                  </th>
                  <th class="text-center">
                    Оновленно
                  </th>
                  <th>
                    Примірників
                  </th>
                  <th class="text-center">
                    Функції
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in descriptions">
                  <td>
                    <b-form-checkbox
                        v-model="item.updateChecked"
                        :checked="item.updateChecked ? true : false"
                    >
                    </b-form-checkbox>
                  </td>
                  <td>
                    <router-link :to="{ name: 'descriptionEdit', params: {id:item.id} }" target="_blank">
                      <b>{{ item.title }}</b>
                      <br>
                      ISBN: <span v-for="el in item.isbn">{{ el.name }}</span>
                    </router-link>
                  </td>
                  <td :class="filterField != null && filterField.field == 'author' ? 'bg-success text-white' : ''"  @click="doubleClick(item.author)">
                    <b>{{ item.author ? item.author.name : ''}}</b><br>
                  </td>
                  <td v-if="filterField != null && filterField.field !== 'author'" class="bg-success text-white">
                    <b v-if="filterField.type" @click="doubleClick(item[filterField.field])">{{ item[filterField.field] ? item[filterField.field].name : ''}}</b>
                    <b v-else-if="filterField.field == 'year' || filterField.field == 'location_publication'" @click="doubleClick(item[filterField.field])">{{ item[filterField.field] }}</b>
<!--                    <b v-else>{{ item[filterField.field].map(el=>el.name).join()}}</b><br>-->
                    <b v-else v-for="(el,key) in item[filterField.field]" @click="doubleClick(el)" :style="filterValue && filterValue.name == el.name ? 'text-decoration:underline;' : ''">{{ el.name }}{{ key != (item[filterField.field].length - 1) ? ';' : ''}}</b><br>
                  </td>
                  <td>
                    <b>{{ item.year }}</b>
                  </td>
                  <td>
                    <b>{{ item.publication ? item.publication.name : '' }}</b>
                  </td>
                  <td>
                    <b>{{ item.location_publication }}</b>
                  </td>
                  <td class="text-center">
                    {{ moment(item.created_at).format("YYYY-MM-DD hh:mm:ss") }}<br>
                    <b>{{ item.library_id && item.library ? item.library.title : 'нема зв\'зку з бібліотекою' }}</b>
                  </td>
                  <td class="text-center">
                    {{ moment(item.updated_at).format("YYYY-MM-DD hh:mm:ss") }}<br>
                  </td>
                  <td>
                    <a :href="'/library/description/' + item.id" target="_blank">{{ item.books.length }}</a>
                  </td>
                  <td class="text-center">
                    <div class="btn btn-danger" @click="deleteDescription(item)">Видалити</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="mr-auto">
                    <div class="m-t-10 p-t-30 m-l-30 footer-card">{{ descriptions.length }} із {{ rows }}
                      записів
                    </div>
              </div>
              <div class="ml-auto">
                <div class="m-t-10 p-t-30">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      @input="getDescriptions()"
                  ></b-pagination>
                  <b-form-input type="number" @change="currentPage = $event"></b-form-input>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';

export default {
  name: "Descriptions",
  components:{
    Loading,DatePicker
  },
  data(){
    return{
      clicks:0,
      delay:700,
      descriptions:[],
      total:0,
      currentPage:1,
      rows:null,
      perPage:null,
      fields:[
        {field:'isbn', type:false, name:'ISBN'},
        {field:'author', type:true, name:'Автор'},
        {field:'coauthors', type:false, name:'Співавтори'},
        {field:'translators', type:false, name:'Перекладачі'},
        {field:'illustrators', type:false, name:'Автори Ілюстрацій'},
        {field:'thematics', type:false, name:'Тематичні рубрики'},
        {field:'key_words', type:false, name:'Ключові слова'},
        {field:'year', type:false, name:'Рік видання'},
        {field:'publication', type:true, name:'Видавництво'},
        {field:'location_publication', type:false, name:'Місце видання'},
        {field:'type_record', type:true, name:'Тип запису'},
        {field:'rubric', type:true, name:'Основна рубрика'},
        {field:'languages', type:false, name:'Мова видання'},
        {field:'language_original', type:true, name:'Мова оригіналу'},
      ],
      checkedAll:false,
      filterValues:[],
      isLoading:false,
      filterField:null,
      filterValue:null,
      changeValue:null,
      dateFilter:false,
      showEmptyField:false,
    }
  },
  mounted() {
    if(Object.keys(this.$route.query).length > 0){
      this.filterField = this.fields.find(el => el.field == this.$route.query.filter);
      if(this.filterField){
        this.getFieldValues(this.filterField.field,'');

        this.showEmptyField = this.$route.query.showEmptyField == 1 ? true : false;
        // if(this.filterField.type && this.$route.query.value){
          this.getFieldValue(this.filterField.field, this.$route.query.value);
        // }else{
        //   this.filterValue = this.$route.query.value ? {title:this.$route.query.value} : null;
        // }
      }
    }else{
      this.getDescriptions();
    }
  },
  watch:{
    showEmptyField(val,oldval){
        this.filterValue = null;
        this.getDescriptions();
    }
  },
  methods:{
    doubleClick(item){
      this.clicks++;
      if(this.clicks === 1){
        setTimeout(() => {
          this.clicks = 0
        }, this.delay);
      }else{
        if(this.filterField.field == 'year' || this.filterField.field == 'location_publication'){
          this.filterValue = {name:item};
        }else{
          this.filterValue = item;
        }
        this.getDescriptions();
      }
    },
    checkAll(){
      this.descriptions = this.descriptions.map(el => {
        if(!this.checkedAll){
          el.updateChecked = false;
        }else {
          el.updateChecked = true;
        }
        return el;
      });
    },
    reset(){
        this.checkedAll = false;
        this.filterField = null;
        this.filterValue = null;
        this.changeValue = null;
        this.dateFilter = false;
        this.getDescriptions();
    },
    deleteDescription(item){
      let title = 'Ви дійсно хочете видалити опис книги';
      if(item.books.length > 0){
        title = 'Ви дійсно хочете видалити опис книги разом з примірниками';
      }
      Swal.fire({
        title: title,
        text: "Для підтвердження напишіть ВИДАЛИТИ",
        input:'text',
        inputValidator:(value) => {
          if(value !== 'ВИДАЛИТИ'){
            return "Для підтвердження напишіть ВИДАЛИТИ"
          }
        },
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Так, видалити',
        cancelButtonText: 'Ні'
      }).then((result) => {
        if (result.value) {
          axios({
            method: 'delete',
            url: '/descriptions/' + item.id
          }).then(response => {
            if(response.data.status === 'success'){
              this.getDescriptions();
              Swal.fire(
                  'Видалено!',
                  '',
                  'success'
              )
            }else{
              Swal.fire(
                  'Не видалено!',
                  response.data.message,
                  'warning'
              )
            }
          });

        }
      })
    },
    getFieldValues(field,title){
      axios.get('/library/settings?field=' + field + '&name=' + title + '&search=true').then(response => {
          this.filterValues = response.data.data;
      });
    },
    getFieldValue(relate,id){
      axios.get('/library/settings/'+id+'?type=' + relate).then(response => {
          this.filterValue = response.data.data;
          this.getDescriptions();
      });
    },
    getDescriptions(event){
      this.isLoading = true;
      this.checkedAll = false;

      axios.get('/descriptions', {params:{
          filter:this.filterField ? this.filterField.field : '',
          showEmptyField:this.showEmptyField ? 1 : 0,
          value:this.filterValue ? (this.filterField.field == 'year' || this.filterField.field == 'location_publication') ? this.filterValue.name : this.filterValue.id : '',
          dateFilter:this.dateFilter ? this.dateFilter : '',
          page:this.currentPage
        }}).then(res => {
        this.total = res.data.total;
        this.perPage = res.data.per_page;
        this.rows = res.data.total;
        this.currentPage = res.data.current_page;

        this.descriptions = res.data.data;
        this.isLoading = false;
      }).catch(err => {
        this.getDescriptions();
        this.$router.push({name: 'descriptions'});
        this.isLoading = false;
      })
    },
    massUpdate(){
      let countCheck = this.descriptions.filter(el=>el.updateChecked).length;
      if(countCheck > 0){
        Swal.fire({
          title: 'Ви дійсно хочете змінити поле',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Так, замінити',
          cancelButtonText: 'Ні'
        }).then((result) => {
          if (result.value) {
            this.isLoading = true;

            axios({
              url: '/descriptions/update',
              method: 'post',
              data: {
                field: this.filterField.field,
                fieldValue: this.filterValue ? this.filterValue.id : '',
                change: this.changeValue,
                descriptions: this.descriptions.filter(el => el.updateChecked).map(el => el.id)
              }
            }).then(() => {
              this.getDescriptions();
            }).catch(error => {
              Swal.fire(
                  'Помилка',
                  'Дане поле обов\'язкове для заповнення',
                  'warning'
              )
              this.getDescriptions();
            });
          }
        });
      }
    },
    moment: function (date) {
      return moment(date);
    },
  }
}
</script>

<style scoped>
  table {
    overflow: hidden;
  }
  td,th {
    max-width: 150px;
  }

</style>